'use client'

import { usePathname, useRouter } from 'next/navigation'

import { ConfirmDialog } from '@/shared/ui'

type Props = {
  isOpen: boolean
  onOpenChange: (open?: boolean) => void
  pathname: string | null
}

export const MoveToSignInDialog = ({
  isOpen,
  onOpenChange,
  pathname: pathnameProp,
}: Props) => {
  const pathname = usePathname()

  const router = useRouter()

  const handleMoveToLoginConfirm = () => {
    onOpenChange(false)
    router.push(`/sign-in?redirect=${pathnameProp || pathname}`)
  }

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title="로그인이 필요합니다."
      content="로그인 페이지로 이동하시겠습니까?"
      cancelText="취소"
      confirmText="로그인하기"
      onConfirm={handleMoveToLoginConfirm}
    />
  )
}
